export enum HsCameraToolType {
  None,
  Default,
  LookAt,
  FocusAt,
  TargetFocusObject,
  TransitionToTargetPointAndRotate,
  RotateOrbit,
  PanoramaMove,
  Landscape,
}
